import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { AgGrid } from '../../../../../../components'
import { getDefaultColumnDef, preventDefaultRowClick } from '../../../../../../utils'

import CustomCellRender from './cell/cell.component'

/**
 * Note List Component
 */
class NoteListComponent extends PureComponent {

  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      columns: [
        { typeOfValue: 'text', field: 'author', headerName: 'Modified By', minWidth: 180, maxWidth: 220 },
        { typeOfValue: 'date', field: 'update_date', headerName: 'Updated', minWidth: 90, maxWidth: 110 },
        { typeOfValue: 'auto-height', field: 'notes', headerName: 'Note', minWidth: 180, autoHeight: true }
      ]
    }
  }

  /**
   * Handle AgGrid onGridReady event
   * @param grid
   * @see: {@link: https://github.com/ag-grid/ag-grid/issues/997}
   */
  handleGridReady = (grid) => {
    setTimeout(() => this.agGrid = grid, 0)
  }

  /**
   * Handle AgGrid gridSizeChanged event
   * @param type - event type
   */
  handleGridResize = ({ type }) => {
    if (type === 'gridSizeChanged') {
      setTimeout(() => this.agGrid && this.agGrid.api.sizeColumnsToFit(), 0)
    }
  }

  /**
   * Handle AgGrid columnResized event
   * @param type
   */
  handleColumnResize = ({ type }) => {
    if (type === 'columnResized') {
      setTimeout(() => this.agGrid && this.agGrid.api.resetRowHeights(), 0)
    }
  }

  /**
   * Handle page change
   * @param selected
   */
  handlePageChange = ({ selected }) => {
    const { handleFilterChange } = this.props

    handleFilterChange({ page: selected })
    this.handleColumnResize({ type: 'columnResized' })
  }

  /**
   * Handle page size change
   * @param selected
   */
  handlePageSizeChange = ({ selected }) => {
    const { handleFilterChange } = this.props

    handleFilterChange({ page: 1, limit: selected })
    this.handleColumnResize({ type: 'columnResized' })
  }

  /**
   * Handle row click event
   * @param _id {String} - activity id
   */
  handleRowClicked = ({ _id }) => {

  }

  /**
   * Renders CustomCell Component
   */
  renderCustomCell = (props) => {
    return (<CustomCellRender {...props} />)
  }

  /**
   * Returns grid columns
   */
  getColumnsDefinition = () => {
    return this.state.columns.map(({ typeOfValue, ...column }, idx) => ({
      ...getDefaultColumnDef(idx, typeOfValue),
      ...column
    }))
  }

  /**
   * Render Contact Grid
   * @return {XML}
   */
  render () {
    const { data, total, filters: { page, limit } } = this.props

    return (
      <AgGrid
        className='data-table notes-grid'
        domLayout='autoHeight'
        sizeToFit={true}

        // suppress configs
        suppressMovableColumns={true}
        suppressContextMenu={true}
        enableCellTextSelection={true}

        // columns and data
        defaultColDef={{
          suppressMenu: true,
          sortable: false,
          cellRenderer: 'CustomCellRender'
        }}
        columnDefs={this.getColumnsDefinition()}
        rowData={data.slice((page - 1) * limit, (page - 1) * limit + limit)}

        // pagination
        pagination={true}
        paginationProps={{
          pageSizeId: 'contact-note-list',
          forcePage: page,
          initialPageSize: limit,
          showPageSizeSelection: true,
          total,
          onPageChange: this.handlePageChange,
          onPageSizeChange: this.handlePageSizeChange
        }}

        // custom components
        frameworkComponents={{
          CustomCellRender: this.renderCustomCell
        }}

        // event listeners
        onGridReady={this.handleGridReady}
        onGridSizeChanged={this.handleGridResize}
        onColumnResized={this.handleColumnResize}
        onRowClicked={preventDefaultRowClick(this.handleRowClicked)}
      />
    )
  }
}

NoteListComponent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    update_date: PropTypes.string.isRequired,
    author: PropTypes.string,
    notes: PropTypes.string,
  })).isRequired,
  total: PropTypes.number.isRequired
}

NoteListComponent.defaultProps = {
  data: [],
  total: 0,
  filter: {
    page: 1,
    limit: 10
  }
}

export default NoteListComponent